var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagedModeMsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8066_8035)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8066_8035",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8066_8035)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8066_8035",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8066_8035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8066_8035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6725 8.16123V15.8388H9.0655V10.6556L8.42358 15.8388H7.28384L6.60699 10.7742V15.8388H5V8.16123H7.37991C7.44978 8.6228 7.52402 9.16657 7.60262 9.79253L7.8559 11.7463L8.27511 8.16123H10.6725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3057 10.4849H13.5983V9.91583C13.5983 9.65027 13.5764 9.48113 13.5328 9.40842C13.4891 9.3357 13.4163 9.29935 13.3144 9.29935C13.2038 9.29935 13.1194 9.34835 13.0611 9.44635C13.0058 9.54436 12.9782 9.69295 12.9782 9.89212C12.9782 10.1482 13.0102 10.341 13.0742 10.4707C13.1354 10.6003 13.3086 10.7568 13.5939 10.9401C14.4119 11.4681 14.9272 11.9012 15.1397 12.2395C15.3523 12.5778 15.4585 13.1231 15.4585 13.8755C15.4585 14.4224 15.3988 14.8255 15.2795 15.0848C15.163 15.344 14.936 15.5621 14.5983 15.7392C14.2606 15.9131 13.8675 16 13.4192 16C12.9272 16 12.5066 15.8988 12.1572 15.6965C11.8108 15.4942 11.5837 15.2365 11.476 14.9235C11.3683 14.6106 11.3144 14.1664 11.3144 13.591V13.0883H13.0218V14.0225C13.0218 14.3102 13.0451 14.4952 13.0917 14.5774C13.1412 14.6596 13.2271 14.7007 13.3493 14.7007C13.4716 14.7007 13.5619 14.6485 13.6201 14.5442C13.6812 14.4398 13.7118 14.2849 13.7118 14.0794C13.7118 13.6273 13.655 13.3318 13.5415 13.1926C13.425 13.0535 13.1383 12.8212 12.6812 12.4956C12.2242 12.1668 11.9214 11.9281 11.7729 11.7795C11.6245 11.6309 11.5007 11.4254 11.4017 11.163C11.3057 10.9006 11.2576 10.5655 11.2576 10.1577C11.2576 9.56965 11.3261 9.1397 11.4629 8.86781C11.6026 8.59593 11.8268 8.38411 12.1354 8.23237C12.444 8.07746 12.8166 8 13.2533 8C13.7307 8 14.1368 8.08378 14.4716 8.25133C14.8093 8.41889 15.032 8.63071 15.1397 8.88678C15.2504 9.1397 15.3057 9.57123 15.3057 10.1814V10.4849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0393 8.16123H17.8908C18.3916 8.16123 18.7758 8.20391 19.0437 8.28927C19.3144 8.37463 19.5167 8.49793 19.6507 8.65916C19.7875 8.82039 19.8792 9.0164 19.9258 9.24718C19.9753 9.47481 20 9.82889 20 10.3094V10.9781C20 11.4681 19.9534 11.8253 19.8603 12.0498C19.7671 12.2743 19.5953 12.4466 19.345 12.5667C19.0975 12.6868 18.7729 12.7469 18.3712 12.7469H17.8777V15.8388H16.0393V8.16123ZM17.8777 9.47481V11.4286C17.9301 11.4317 17.9753 11.4333 18.0131 11.4333C18.182 11.4333 18.2984 11.3891 18.3624 11.3005C18.4294 11.2089 18.4629 11.0207 18.4629 10.7362V10.1055C18.4629 9.84311 18.425 9.6724 18.3493 9.59336C18.2737 9.51433 18.1164 9.47481 17.8777 9.47481Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8066_8035",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8066_8035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedModeMsp);
export default __webpack_public_path__ + "static/media/ManagedMode-Msp.0b94aeccb0cab2e107d0754c183b764a.svg";
export { ForwardRef as ReactComponent };